// @flow
import React from 'react';
import Modal from 'react-modal';
import SimpleBar from 'simplebar-react';
import { useViewport } from 'components/templates/viewportProvider';
import chevronRightIcon from 'assets/images/rightb.png';
import { GetInTouchForm } from 'components/organisms/getInTouchForm';

// eslint-disable-next-line
import styles from "components/templates/getInTouchModal/styles.scss";

type Props = {
  isOpen: boolean,
  onClosePress: () => void,
  campaignCode?: string,
  projectInterested?: string,
};

export const DownloadBrochureModal = (props: Props) => {
  const { isMobile } = useViewport();
  const {
    isOpen,
    onClosePress,
    campaignCode,
    projectInterested,
    callPostLeadAPI,
    salesEmail,
    pdfUrl,
  } = props;

  const onClose = () => {
    onClosePress();
  };

  const fetchUrl = window.location.href;
  const url = new URL(fetchUrl);
  const utmParameters = {
    UTMSource: url.searchParams.get('utm_source'),
    UTMMedium: url.searchParams.get('utm_medium'),
    UTMCampaign: url.searchParams.get('utm_campaign'),
    UTMDisplay: url.searchParams.get('utm_display'),
    UTMTerm: url.searchParams.get('utm_term'),
    UTMContent: url.searchParams.get('utm_content'),
    CampaignCode: campaignCode ? campaignCode : '',
    ProjectInterested: projectInterested ? projectInterested : '',
  };
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClosePress}
      overlayClassName={'modal-overlay normal-scroll'}
      className={`get-in-touch-overlay-content ${isMobile ? 'mobile' : ''}`}
    >
      <div className={'get-in-touch-modal'}>
        <a className={'collapse-icon-container'} onClick={onClose}>
          <img src={chevronRightIcon} alt={'icon'} />
        </a>
        <SimpleBar autoHide={true} style={{ height: '100%' }}>
          <div>
            <span className={'label'}>For more information,</span>
            <h2>Enter details to download Brochure</h2>
            <h3>PDF Format with all the specs</h3>
          </div>
          <GetInTouchForm
            onSubmitSuccess={onClose}
            isMobile={isMobile}
            utmParameters={utmParameters}
            salesEmail={salesEmail}
            callPostLeadAPI={callPostLeadAPI}
            type={'brochure'}
            pdfUrl={pdfUrl}
          />
        </SimpleBar>
      </div>
    </Modal>
  );
};
